import { 
	GetGradingScaleActionsTypes,
	GetGradingScalesActionsTypes,
	CreateGradingScaleActionsTypes, CreateGradingScaleModel,
	UpdateGradingScaleActionsTypes, UpdateGradingScaleModel,
	DeleteGradingScaleActionsTypes
} from './types';

export const getGradingScaleRequest  = (id: number) => (
	{
		type: GetGradingScaleActionsTypes.GET_GRADING_SCALE,
		id : id
	}
);

export const getGradingScalesRequest  = () => (
	{
		type: GetGradingScalesActionsTypes.GET_GRADING_SCALES,		
	}
);

export const createGradingScaleRequest  = (model: CreateGradingScaleModel) => (
	{
		type: CreateGradingScaleActionsTypes.POST_CREATE_GRADING_SCALE,
		model		
	}
);

export const updateGradingScaleRequest  = (id: number, model: UpdateGradingScaleModel) => (
	{
		type: UpdateGradingScaleActionsTypes.PUT_UPDATE_GRADING_SCALE,
		id,
		model		
	}
);

export const deleteGradingScaleRequest  = (id: number) => (
	{
		type: DeleteGradingScaleActionsTypes.DELETE_GRADING_SCALE,	
		id : id
	}
);
